import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'

/**
 * Displays the measurement's location.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {React.JSX.Element}
 */
const ListItemCellXEcoApmLocation = (classes, props = {}) => {
  const { events } = props
  const [locationItem] = events?.getLocationValues(props.location) || []
  const location = locationItem?.value ?? props.location ?? '-'

  return (
    <Text
      color={'black'}
      variant={'14/regular'}
      className={classes.row}
    >
      {location}
    </Text>
  )
}

export default CellHOC(ListItemCellXEcoApmLocation)
